import { Stack } from '@src/shared/ui/layout';
import { useContext } from 'react';
import { ToastContext } from './context';
import Toast from './Toast';

const StyleSheet = {
  container: {
    position: 'absolute',
    top: '-20px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '700px',
    zIndex: 10,
  },
};

export default function ToastContainer() {
  const ctx = useContext(ToastContext);
  if (!ctx || ctx.toasts.length === 0) return null;

  return (
    <Stack spacing={0.5} sx={StyleSheet.container}>
      {ctx.toasts.map((toast) => (
        <Toast
          key={toast.id}
          title={toast.title}
          description={toast.description}
          severity={toast.severity}
          onDismiss={() => ctx.dismiss(toast.id)}
        />
      ))}
    </Stack>
  );
}
